import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck} from '@fortawesome/pro-regular-svg-icons';
import {faFileChartColumn} from '@fortawesome/pro-solid-svg-icons';
import axios from 'axios';
import {Button} from '@/components/common-components';
import moment from 'moment';

interface TracerReportButtonProps {
  traceId: string;
  status?: number;
  description?: string | React.ReactNode;
  message?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const TracerReportButton = ({traceId, status, description, message, onClick, disabled}: TracerReportButtonProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitReport = async () => {
    if (isSubmitted || isSubmitting || disabled) return;

    setIsSubmitting(true);
    try {
      const response = await axios.post(`${window.location.origin}/api/report-problem`, {
        trace_id: traceId,
        detected_at: moment(new Date()).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        service_name: process.env.NEXT_PUBLIC_OTEL_ATTR_SERVICE_NAME,
        additional_attributes: {
          user_agent: navigator.userAgent,
          component_location: status === 0 ? 'FrontendError' : 'APIError',
          error_message: typeof description === 'string' ? description : message,
        },
      });

      if (response?.data?.success) {
        setIsSubmitted(true);
        onClick?.();
      }
    } catch (error) {
      // Error state handled by UI
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitted ? (
        <Button buttonType='green' style={{width: '195px'}}>
          Report Submitted <FontAwesomeIcon icon={faCheck} />
        </Button>
      ) : (
        <Button
          buttonType='error'
          onClick={handleSubmitReport}
          disabled={isSubmitting || disabled}
          style={{width: '195px'}}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Report'} <FontAwesomeIcon icon={faFileChartColumn} />
        </Button>
      )}
    </>
  );
};
